import { AppBox, AppDialog } from 'components'
import { useNewsAlert } from 'hooks'
import { NewAlertsActions } from 'views'
import { AddEditNewsAlertForm } from './add-edit-news-alert-form/AddEditNewsAlertForm'
import { NewAlertsListing } from './listing/NewAlertsListing'

export const AddNewsAlerts = () => {
  const {
    isAdding,
    idToUpdate,
    isGetting,
    isEditing,
    filterdAlerts,
    filter,
    setFilter,
    control,
    handleSubmit,
    setValue,
    dialogRef,
    openDialog,
    isDeleting,
    handleDeleteNewsAlert,
    submitForm,
  } = useNewsAlert()

  return (
    <AppBox minHeight={'inherit'}>
      <AppBox paddingX={2}>
        <NewAlertsActions filter={filter} setFilter={setFilter} openDialog={openDialog} />
      </AppBox>
      <AppBox paddingX={2} minHeight={'inherit'}>
        <NewAlertsListing
          filter={filter}
          setFilter={setFilter}
          filterdAlerts={filterdAlerts}
          isGetting={isGetting || isDeleting}
          onEditClick={openDialog}
          onRemoveClick={handleDeleteNewsAlert}
        />
      </AppBox>
      <AppDialog
        maxWidth="sm"
        ref={dialogRef}
        title={idToUpdate ? 'Edit News Alert' : 'Add News Alert'}
        appDialogWrapperProps={{
          component: 'form',
          role: 'form',
          onSubmit: handleSubmit((data) => submitForm(data)),
        }}
        submitButtonProps={{ isLoading: isAdding || isEditing }}
        renderChild={(openDialog) => <AddEditNewsAlertForm control={control} setValue={setValue} />}
      />
    </AppBox>
  )
}
